import { render, staticRenderFns } from "./ContactGroup.vue?vue&type=template&id=109206b0&scoped=true&"
import script from "./ContactGroup.vue?vue&type=script&lang=js&"
export * from "./ContactGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109206b0",
  null
  
)

export default component.exports